export const BaseUrl = () => {
  if (!window || !window.location) return '';
  return window.location.origin || '';
};
